<template>
  <div class="userbox"
       :class="{collapse : collapse}">
    <transition name="sidebarLogoFade">
      <div>
        <img src="../../../assets/img/user_img.png"
             alt="">
        <div class="userinfo">
          <p v-show="!collapse">{{name}}</p>
          <svg-icon icon-class="dropout"
                    @click.native="logout" />
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { uploadUrl } from '@/api/fsl'
export default {
  props: {
    collapse: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'name',
      'logo'
    ])
  },
  methods: {
    uploadUrl,
    async logout () {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}
.userbox {
  // background: url(~@/assets/img/sidebg_01.png) center bottom no-repeat;
  height: 220px;
  text-align: center;
  padding: 30px 10px;
  color: #e8e8e8;
  img {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    margin-bottom: 15px;
  }
  .userinfo {
    display: flex;
    font-size: 20px;
    justify-content: center;
    align-items: center;
    p {
      margin: 15px 0;
      margin-right: 10px;
    }
    .svg-icon {
      margin: 0 !important;
      cursor: pointer;
    }
  }
}
.userbox.collapse {
  height: 120px;
  img {
    width: 35px;
    height: 35px;
  }
}
</style>